import {
    apiRequest,
    homeList,
    homeActive,
    homeInactive
} from "../../../../../../services/adapters/kepegawaian/homeService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", homeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", homeInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", homeActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository